// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const CampaignCalloutContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-campaigncalloutcontainer" */ "./CampaignCalloutContainer")).then((bundle)=>{
        return {
            default: bundle.CampaignCalloutContainer
        };
    });
export const LazyCampaignCalloutContainer = /*#__PURE__*/ lazy(CampaignCalloutContainerLazyLoader);
